<div class="b-flex-row b-flex-wrap">
  <div>
    <div class="b-flex-row">
      <ng-template #titleContent>
        <span [innerHTML]="title"></span>
        <ng-content></ng-content>
        <span class="b-page-header__title-details"><span [innerHTML]="subtitle" (click)="toggleMenu($event)"></span>
          <ng-content select="f-facet[name=subtitle],[facet-subtitle]"></ng-content>
        </span>
      </ng-template>
      @switch (level) {
        @case (2) { <h2 class="b-page-header__title" [ngStyle]="{'text-transform': disableUppercase?'none':''}"><ng-container *ngTemplateOutlet="titleContent"></ng-container></h2> }
        @case (3) { <h3 class="b-page-header__title" [ngStyle]="{'text-transform': disableUppercase?'none':''}"><ng-container *ngTemplateOutlet="titleContent"></ng-container></h3> }
        @case (4) { <h4 class="b-page-header__title" [ngStyle]="{'text-transform': disableUppercase?'none':''}"><ng-container *ngTemplateOutlet="titleContent"></ng-container></h4> }
        @case (5) { <h5 class="b-page-header__title" [ngStyle]="{'text-transform': disableUppercase?'none':''}"><ng-container *ngTemplateOutlet="titleContent"></ng-container></h5> }
        @case (6) { <h6 class="b-page-header__title" [ngStyle]="{'text-transform': disableUppercase?'none':''}"><ng-container *ngTemplateOutlet="titleContent"></ng-container></h6> }
        @default { <h1 class="b-page-header__title" [ngStyle]="{'text-transform': disableUppercase?'none':''}"><ng-container *ngTemplateOutlet="titleContent"></ng-container></h1> }
      }
      <button *ngIf="hasPortfolio" class="b-portfolio__dropdown-button"  [ngClass]="{'b-portfolio__dropdown--is-active': showPortfolio}" (click)="toggleMenu($event)"></button>
    </div>
    <div [hideEmpty]="3" class="b-portfolio" (click)="toggleMenu($event)">
      <div #p class="b-portfolio__dropdown" [ngClass]="{'b-portfolio__dropdown--is-active': showPortfolio}"
        [style.right]="portfolioRight" [style.left]="portfolioLeft">
        <ul class="b-portfolio__list" #portfolios (click)="showPortfolio=false;$event.stopPropagation()">
          <ng-content select="li[facet-portfolio-list],f-facet[name=portfolio-list]"></ng-content>
        </ul>
      </div>
    </div>
  </div>
  <div class="b-flex-grow"></div>
  <div class="b-page-header__actions b-flex-row" style="flex: 1 0 auto">
    <div class="b-flex-grow"></div>
    <div *ngIf="statusText" class="b-page-header__status-text" [innerHTML]="statusText"></div>
    <div class="b-page-header__status-text" hide-empty>
      <ng-content select="f-facet[name=status],[facet-status]"></ng-content>
    </div>
    <ng-content select="f-facet[name=actions],[facet-actions]"></ng-content>
  </div>
</div>
